import { WaypointKind as WaypointKindSchema, type WaypointKind } from '@xingroute/schema'

export const WAYPOINT_KINDS: readonly WaypointKind[] = WaypointKindSchema.options
